// extracted by mini-css-extract-plugin
export var chevronIcon = "_70-2";
export var teamName = "_70-1";
export var teamSwitcherButton = "_70-0";